<template>
  <div class="create-campaign-review-card__text-wrapper">
    <div class="create-campaign-review-card__text">
      <b><slot name="label" /></b>

      <template v-if="!edit">
        <slot />
      </template>
    </div>

    <review-textarea
      v-if="edit"
      ref="textarea"
      v-model="modelValue"
      :rules="rules"
      :autofocus="edit"
      :hide-details="false"
      :validate-on-blur="false"
      @exitEditMode="edit = false"
    />

    <button v-else @click="edit = true">
      Edit
    </button>
  </div>
</template>

<script>
import ReviewTextarea from '../myCampaign/panels/sendEgift/components/ReviewTextarea.vue'

export default {
  name: 'CreateCampaignReviewCardEditInput',
  components: { ReviewTextarea },
  props: {
    value: {
      type: String,
      required: false,
      default: null,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [v => !!v || ''],
    },
    startInEditMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data () {
    return {
      edit: this.startInEditMode,
    }
  },
  computed: {
    modelValue: {
      get () { return this.value },
      set (val) { this.$emit('input', val) },
    }
  },
  methods: {
    forceEditMode () {
      this.edit = true
    },
    // commits whatever is currently typed (if valid) instead of requiring an explicit save click
    commit () {
      if (!this.edit) { return true }

      return this.$refs.textarea.commitIfValid()
    },
  },
}
</script>

<style lang="scss" scoped>
.create-campaign-review-card__text-wrapper {
  align-items: baseline;

  & > button {
    border: none;
    background-color: transparent;
    font-family: 'Lato-Regular', sans-serif;
    line-height: 21.28px;
    font-weight: 400;
    font-size: 16px;
    color: #6E50FF;
  }
}
</style>
